export { goalbookUrls, pathwaysUrls, toolkitUrls, urlHelpers, getStrategyUrl, getGoalUrl, getPresentLevelsUrl, getImpactOfDisabilityUrl, threadsUrls }

const goalbookUrls = {}

const dnsName = import.meta.env.VITE_DNS_NAME || 'goalbookapp.com'

goalbookUrls.toolkit = import.meta.env.VITE_TOOLKIT_URL
goalbookUrls.toolkitHome = `${import.meta.env.VITE_TOOLKIT_URL}/v`
goalbookUrls.pathways = import.meta.env.VITE_PATHWAYS_URL
goalbookUrls.pathwaysApi = `${goalbookUrls.pathways}/api/v1`
goalbookUrls.presentlevels = import.meta.env.VITE_PRESENTLEVELS_URL
goalbookUrls.accounts = import.meta.env.VITE_ACCOUNTS_URL
goalbookUrls.auth = import.meta.env.VITE_AUTH_URL
goalbookUrls.threads = import.meta.env.VITE_THREADS_URL
goalbookUrls.signUp = `${goalbookUrls.accounts}/users/sign_up`
goalbookUrls.signIn = `${goalbookUrls.accounts}/users/sign_in`
goalbookUrls.googleOauth2 = `${goalbookUrls.accounts}/auth/google_oauth2`
goalbookUrls.signOut = `${goalbookUrls.toolkit}/sign_out`
goalbookUrls.forgotPassword = `${goalbookUrls.accounts}/users/password/new`
goalbookUrls.lms = import.meta.env.VITE_LMS_URL
goalbookUrls.upcomingWebinars = 'https://toolkit-webinars.goalbook.com/home'
goalbookUrls.recentUpdates = 'https://goalbook.com/category/innovation/'

const toolkitUrls = {
  routerBase: import.meta.env.VITE_ROUTER_BASE,
  home: goalbookUrls.toolkit,
  api: `${goalbookUrls.toolkit}/api`,
  apiBases: {
    collections: `${goalbookUrls.toolkit}/api/collections`,
    library: `${goalbookUrls.toolkit}/api/library`
  },
  contentProfilesEndpoint: `${goalbookUrls.toolkit}/content_profile`,
  browse: `${goalbookUrls.toolkit}/v/browse`,
  browseStrategies: `${goalbookUrls.toolkit}/v/browse/strategies`,
  browseAssessments: `${goalbookUrls.toolkit}/v/browse/assessments`,
  assessmentWizard: `${goalbookUrls.toolkit}/v/wizard/assessments`,
  goalWizard: `${goalbookUrls.toolkit}/v/wizard`,
  strategiesWizard: `${goalbookUrls.toolkit}/v/strategies/wizard`,
  presentlevelsWizard: `${goalbookUrls.toolkit}/v/presentlevels`,
  browsePresentLevels: `${goalbookUrls.toolkit}/v/browse/presentlevels`,
  impactOfDisability(aiFeatureVisibility, betaVisibility = false) {
    if (aiFeatureVisibility) {
      return `${goalbookUrls.toolkit}/v/impact-of-disability` + (betaVisibility ? '?beta=true' : '')
    }
    return `${goalbookUrls.toolkit}/v/impact` + (betaVisibility ? '?beta=true' : '')
  },
  strategyPage(id) {
    return `${toolkitUrls.routerBase}strategy/${id}`
  },
  goalPage(id) {
    return `${toolkitUrls.routerBase}goal/${id}`
  },
  anchorPage(id) {
    return `${toolkitUrls.routerBase}anchor-page/${id}`
  },
  libraryPresentLevelsSubjectSummaryPage(id) {
    return `${toolkitUrls.routerBase}presentlevels/v2/summary/${id}`
  },
  libraryStrategyPage(id) {
    return `${toolkitUrls.routerBase}library/strategy/${id}`
  },
  librarySharedStrategyPage(id) {
    return `${toolkitUrls.routerBase}share/strategy/${id}`
  },
  libraryGoalPage(id) {
    return `${toolkitUrls.routerBase}library/goal/${id}`
  },
  libraryAnchorPage(id) {
    return `${toolkitUrls.routerBase}library/anchor-page/${id}`
  },
  librarySharedGoalPage(id) {
    return `${toolkitUrls.routerBase}share/goal/${id}`
  },
  librarySharedAnchorPage(id) {
    return `${toolkitUrls.routerBase}share/anchor-page/${id}`
  },
  libraryPresentLevelsConclusion(id) {
    return `${toolkitUrls.routerBase}presentlevels/conclusion/${id}`
  },
  librarySharedPresentLevels(id) {
    return `${toolkitUrls.routerBase}share/presentlevels/${id}`
  },
  librarySharedPresentLevelsSummary(id) {
    return `${toolkitUrls.routerBase}share/presentlevels/summary/${id}`
  },
  blogPosts: `${goalbookUrls.toolkit}/blog/posts`,
  toolkitUpdates: 'https://goalbook.com/category/innovation/',
  share: `${goalbookUrls.toolkit}/share`,
  subscribe: `https://${dnsName}/explore-toolkit/#get-started`,
  subscribeUniversity: `${goalbookUrls.toolkit}/subscribe/university`,
  library: `${goalbookUrls.toolkit}/library`,
  account: `${goalbookUrls.toolkit}/account`,
  userList: `${goalbookUrls.toolkit}/admin`,
  webinars: 'https://toolkit-webinars.goalbook.com/home',
  pastWebinars: 'https://toolkit-webinars.goalbook.com/past-webinars',
  editorLinks: {
    editGoal(id) {
      return `${goalbookUrls.toolkit}/edit/goal/${id}`
    },
    editStrategy(id) {
      return `${goalbookUrls.toolkit}/edit/strategy/${id}`
    },
    editStandard(id) {
      return `${goalbookUrls.toolkit}/edit/standard/${id}`
    },
    strategiesAdmin: `${goalbookUrls.toolkit}/strategies/list`,
    goalsAdmin: `${goalbookUrls.toolkit}/filter`,
    researchCitations: `${goalbookUrls.toolkit}/research/list`,
    myGoals(authorId) {
      return `${goalbookUrls.toolkit}/filter/#?author_id=${authorId}`
    },
    prekStandards: `${goalbookUrls.pathways}/v/admin/standards/NY-PreK`,
    widaStandards: `${goalbookUrls.toolkit}/standards/wida`,
    caEldStandards: `${goalbookUrls.pathways}/v/admin/standards/CA-ELD`,
    ilsSelStandards: `${goalbookUrls.pathways}/v/admin/standards/ILS-SEL`,
    dlmStandards: `${goalbookUrls.pathways}/v/admin/standards/DLM-EE`,
    ncscStandards: `${goalbookUrls.toolkit}/standards/ncsc-ccc`,
    coachStandards: `${goalbookUrls.pathways}/v/admin/standards/COACH`,
    teksStandards: `${goalbookUrls.pathways}/v/admin/standards/TEKS`,
    teks2017Standards: `${goalbookUrls.pathways}/v/admin/standards/TEKS-2017`,
    udlStandards: `${goalbookUrls.toolkit}/standards/udl`,
    allStandards: `${goalbookUrls.pathways}/v/admin/standards`,
    addGoal: `${goalbookUrls.toolkit}/add/goal`,
    addStrategy: `${goalbookUrls.toolkit}/add/strategy`,
    addResearchCitation: `${goalbookUrls.toolkit}/add/research`
  },
  homepageAssets: {
    strategiesImg: 'https://assets.goalbookapp.com/images/strategies_image.svg',
    goalsImg: 'https://assets.goalbookapp.com/images/goals_image.svg',
    presentLevelsImg: 'https://assets.goalbookapp.com/images/presentlevels_image.svg'
  }
}

const pathwaysUrls = {
  home: goalbookUrls.pathways,
  resourceDetail(id) {
    return `${goalbookUrls.pathways}/#!/resources/${id}`
  },
  editItem(id) {
    return `${goalbookUrls.pathways}/#!/items/${id}/edit`
  },
  itemDetail(id) {
    return `${goalbookUrls.pathways}/#!/items/${id}`
  },
  editStandard(setCode, standardRef) {
    return `${goalbookUrls.pathways}/#!/admin/standards/${setCode}/${standardRef}`
  }
}

class ThreadsUrls {
  baseUrl = goalbookUrls.threads
  saved = `${this.baseUrl}/saved`
}

const threadsUrls = new ThreadsUrls()

const urlHelpers = {
  originAndBase: `${window.location.protocol}//${window.location.host}${import.meta.env.VITE_ROUTER_BASE}`,
  signInReturn(returnUrl) {
    let returnUrlFragment = ''
    if (returnUrl) returnUrlFragment = `?return_url=${encodeURIComponent(returnUrl)}`
    return `${goalbookUrls.signIn}${returnUrlFragment}`
  },
  signUpReturn(product = 'toolkit', returnUrl) {
    let returnUrlFragment = ''
    if (returnUrl) returnUrlFragment = `?return_url=${encodeURIComponent(returnUrl)}`
    return `${goalbookUrls.signUp}/${product}${returnUrlFragment}`
  },
  betaModeUrl(url) {
    return `${url}?beta=true`
  }
}

const getGoalUrl = ({ id, isShared, isSaved, isSuperPage }) => {
  let url
  if (isShared) {
    url = isSuperPage ? toolkitUrls.librarySharedAnchorPage(id) : toolkitUrls.librarySharedGoalPage(id)
  } else if (isSaved) {
    url = isSuperPage ? toolkitUrls.libraryAnchorPage(id) : toolkitUrls.libraryGoalPage(id)
  } else {
    url = isSuperPage ? toolkitUrls.anchorPage(id) : toolkitUrls.goalPage(id)
  }
  return url
}

const getStrategyUrl = ({ id, isShared, isSaved }) => {
  let url
  if (isShared) {
    url = toolkitUrls.librarySharedStrategyPage(id)
  } else if (isSaved) {
    url = toolkitUrls.libraryStrategyPage(id)
  } else {
    url = toolkitUrls.strategyPage(id)
  }
  return url
}

const getPresentLevelsUrl = ({ id, isShared }) => {
  let url
  if (isShared) {
    url = toolkitUrls.librarySharedPresentLevels(id)
  } else {
    url = toolkitUrls.libraryPresentLevelsConclusion(id)
  }
  return url
}

const getImpactOfDisabilityUrl = ({ id, betaVisibility = false, isShared = false }) => {
  let baseUrl = `${toolkitUrls.routerBase}library/iod/${id}`
  if (isShared) {
    baseUrl = `${toolkitUrls.routerBase}share/iod/${id}`
  }
  return betaVisibility ? `${baseUrl}?beta=true` : baseUrl
}
